const toFiniteCoordinate = (value, minimum, maximum) => {
  if (
    value === null ||
    value === undefined ||
    value === "" ||
    (typeof value === "string" && !value.trim())
  ) {
    return null;
  }

  const coordinate = Number(value);
  return Number.isFinite(coordinate) &&
    coordinate >= minimum &&
    coordinate <= maximum
    ? coordinate
    : null;
};

export const getMappableOrganizationLocations = profile => {
  if (!profile) return [];

  const otherLocations = Array.isArray(profile.other_locations)
    ? profile.other_locations
    : [];
  const locations = [
    { lat: profile.main_lat, lng: profile.main_long },
    ...otherLocations
  ];

  return locations.reduce((validLocations, location) => {
    if (
      !location ||
      (location.visible !== undefined && location.visible !== true)
    ) {
      return validLocations;
    }

    const lat = toFiniteCoordinate(location.lat, -90, 90);
    const lng = toFiniteCoordinate(location.lng, -180, 180);
    if (lat === null || lng === null) return validLocations;

    validLocations.push({ ...location, lat, lng });
    return validLocations;
  }, []);
};

export const formatOrganizationAddress = profile => {
  if (!profile) return "";

  return [
    profile.address1,
    profile.address2,
    profile.city,
    profile.province,
    profile.postalcode,
    profile.country
  ]
    .filter(value => typeof value === "string" && value.trim())
    .map(value => value.trim())
    .join(", ");
};
